import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthStateType } from '@/Types/auth.interface';
import { verifyLogin } from './authActions';
import { REHYDRATE } from 'redux-persist';

const initialState: AuthStateType = {
  loading: false,
  user: {},
  userToken: '',
  error: null,
  isLoggedIn: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signOut: state => {
      state.loading = false;
      state.user = {};
      state.userToken = '';
      state.isLoggedIn = false;
      state.error = null;
    }
  },
  extraReducers: builder => {
    builder.addCase(verifyLogin.pending, state => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(verifyLogin.fulfilled, (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.userToken = action.payload.data.token;
      state.user = action.payload.data.admin;
      state.isLoggedIn = true;
      state.error = null;
    });
    builder.addCase(verifyLogin.rejected, (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(REHYDRATE, state => {
      if (state?.user?.email) {
        state.isLoggedIn = true;
      } else {
        return initialState;
      }
    });
  }
});

export const { signOut } = authSlice.actions;

export default authSlice.reducer;
